import { AdvDate } from 'super-engine';

import * as Min from './min';
import * as Max from './max';
import * as Step from './step';
import * as Range from './range';
import * as Disabled from './disabled';
import * as BeforeSet from './beforeSet';
import * as AfterSet from './afterSet';
import { Constants } from '@/constants';

// import { findLowestInvestmentOption, findHighestInvestmentOption } from './helpers';

const { version } = require('../../package.json');

export default {
  env: {
    value: {
      NODE_ENV: process.env.NODE_ENV,
      VERSION: version,
    },
  },

  ui: {
    showCustomInvestment: { value: false },
    graphType: {
      value: 'income',
      afterSet: AfterSet.GraphType,
    },
    showYourPartnerTab: {
      value: false,
    },
    breakdown: {
      show: {
        value: false,
        afterSet: AfterSet.BreakdownShow,
      },
      age: {
        value: 80,
        range: {
          min: Min.BreakdownAge,
          max: 100,
        },
        step: 1,
        beforeSet: BeforeSet.Clamp,
        afterSet: AfterSet.BreakdownAge,
      },
    },
  },

  inferred: {
    InTodaysTerms: { value: true },

    WageInflation: {
      value: 0.037,
      range: {
        min: 0,
        max: 10,
      },
      step: 1,
      beforeSet: BeforeSet.ClampPercent,
      afterSet: AfterSet.WageInflation,
    },

    PriceInflation: {
      value: 0.025,
      range: {
        min: 0,
        max: 10,
      },
      step: 1,
      beforeSet: BeforeSet.ClampPercent,
      afterSet: AfterSet.PriceInflation,
    },

    CustomOption: { value: 3 },

    // GrossReturn: {
    //   value: 0.0635,
    //   range: {
    //     min() { return findLowestInvestmentOption().grossReturn * 100; },
    //     max() { return findHighestInvestmentOption().grossReturn * 100; },
    //   },
    //   step: 0.1,
    //   beforeSet: BeforeSet.ClampPercent,
    // },

    GrossReturn: {
      value: 0.065,
      range: {
        min: Constants.MIN_CUSTOM_INVESTMENT_VALUE,
        max: Constants.MAX_CUSTOM_INVESTMENT_VALUE,
      },
      step: 0.1,
      beforeSet: BeforeSet.ClampPercent,
    },

    TaxableFraction: { value: 0 },

    FeePercentageOnBalance: {
      value: 0,
      range: {
        min: 0,
        max: 3,
      },
      step: 0.01,
      beforeSet: BeforeSet.ClampPercent,
    },

    FeePercentageOnBalanceCapped: {
      value: 0.0006,
      range: {
        min: 0,
        max: 3,
      },
      step: 0.01,
      beforeSet: BeforeSet.ClampPercent,
    },

    FeePercentageOnBalanceCappedCap: {
      value: 500,
      range: {
        min: 0,
        max: 5000,
      },
      step: 5,
      beforeSet: BeforeSet.Clamp,
    },

    FeePercentageOnContributions: {
      value: 0,
      range: {
        min: 0,
        max: 3,
      },
      step: 0.2,
      beforeSet: BeforeSet.ClampPercent,
    },

    FeeAnnualDollar: {
      value: 62.40,
      range: {
        min: 0,
        max: 500,
      },
      step: 1,
      beforeSet: BeforeSet.Clamp,
    },

    EmployerType: {
      value: 1,
      afterSet: AfterSet.EmployerType,
    },

    HasChangedSalary: { value: false },

    Salary: {
      value: 70000,
      range: {
        min: 0,
        '25%': [13000, 1000],
        '50%': [75000, 1000],
        max: 500000,
      },
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.Salary,
    },

    DefinedBenefit: {
      value: 0,
      range: Range.TwoMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.DefinedBenefit,
    },

    AccruedDBMultiple: { value: 0 },

    PreTaxMemberContributionsFrequency: {
      value: 1,
      afterSet: AfterSet.PreTaxMemberContributionsFrequency,
    },

    PreTaxMemberContributions: {
      value: 0,
      range: {
        min: 0,
        max: Max.PreTaxMemberContributions,
      },
      step: Step.PreTaxMemberContributions,
      beforeSet: BeforeSet.RoundedClamp,
      afterSet: AfterSet.PreTaxMemberContributions,
    },

    PostTaxMemberContributionsFrequency: {
      value: 1,
      afterSet: AfterSet.PostTaxMemberContributionsFrequency,
    },

    PostTaxMemberContributions: {
      value: 0,
      range: {
        min: 0,
        max: Max.PostTaxMemberContributions,
      },
      step: Step.PostTaxMemberContributions,
      beforeSet: BeforeSet.RoundedClamp,
      afterSet: AfterSet.PostTaxMemberContributions,
    },

    DBContributionRate: { value: 0.05 },

    QSuperAccumulationMemberContributionRate: { value: 0.05 },

    MemberContributions: {
      value: 0.05,
      range: Range.MemberContributions(),
      step: 1,
      beforeSet: BeforeSet.MemberContributions,
      afterSet: AfterSet.ContributionRate,
    },

    EmployerContributionRate: {
      value: 0.1275,
      range: {
        min: 11.5,
        max: 20,
      },
      step: 0.25,
      disabled: Disabled.EmployerContributionRate,
      beforeSet: BeforeSet.ClampPercent,
      afterSet: AfterSet.EmployerContributionRate,
    },

    Accumulation: {
      value: 0,
      range: Range.TwoMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.SuperannuationBalance,
    },

    OtherFunds: {
      value: 0,
      range: Range.TwoMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.SuperannuationBalance,
    },

    OneOffPurchase: {
      value: 0,
      range: Range.OneMillion(1000),
      step: 1000,
      afterSet: AfterSet.OneOffPurchase,
    },

    HasChangedTargetIncome: { value: false },

    TargetIncome: {
      value: 46200,
      range: Range.FiveHundredThousand(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.TargetIncome,
    },
    PreservationAge: { value: 60 },

    HasChangedSalary_2: { value: false },

    Salary_2: {
      value: 70000,
      range: {
        min: 0,
        '25%': [13000, 1000],
        '50%': [75000, 1000],
        max: 500000,
      },
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.Salary2,
    },

    EmployerType_2: {
      value: 1,
      afterSet: AfterSet.EmployerType2,
    },

    DBContributionRate_2: { value: 0.05 },

    QSuperAccumulationMemberContributionRate_2: { value: 0.05 },

    MemberContributions_2: {
      value: 0.05,
      range: Range.MemberContributions(),
      step: 1,
      beforeSet: BeforeSet.MemberContributions,
      afterSet: AfterSet.ContributionRate2,
    },

    EmployerContributionRate_2: {
      value: 0.1275,
      range: {
        min: 11.5,
        max: 20,
      },
      step: 0.25,
      disabled: Disabled.EmployerContributionRate2,
      beforeSet: BeforeSet.ClampPercent,
      afterSet: AfterSet.EmployerContributionRate2,
    },

    DefinedBenefit_2: {
      value: 0,
      range: Range.TwoMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.DefinedBenefit2,
    },

    AccruedDBMultiple_2: { value: 0 },

    PreTaxMemberContributionsFrequency_2: {
      value: 1,
      afterSet: AfterSet.PreTaxMemberContributionsFrequency2,
    },

    PreTaxMemberContributions_2: {
      value: 0,
      range: {
        min: 0,
        max: Max.PreTaxMemberContributions2,
      },
      step: Step.PreTaxMemberContributions2,
      beforeSet: BeforeSet.RoundedClamp,
      afterSet: AfterSet.PreTaxMemberContributions2,
    },

    PostTaxMemberContributionsFrequency_2: {
      value: 1,
      afterSet: AfterSet.PostTaxMemberContributionsFrequency2,
    },

    PostTaxMemberContributions_2: {
      value: 0,
      range: {
        min: 0,
        max: Max.PostTaxMemberContributions2,
      },
      step: Step.PostTaxMemberContributions2,
      beforeSet: BeforeSet.RoundedClamp,
      afterSet: AfterSet.PostTaxMemberContributions2,
    },

    Accumulation_2: {
      value: 0,
      range: Range.TwoMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.SuperannuationBalance2,
    },

    OtherFunds_2: {
      value: 0,
      range: Range.TwoMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.SuperannuationBalance2,
    },

    PreservationAge_2: { value: 60 },

    InsurancePremium: {
      value: 468,
      range: {
        min: 0,
        max: 10000,
      },
      // afterSet: AfterSet.ToggleInsurancePremiumOverride,
    },

    OverrideFundDefaultInsurancePremiums: {
      value: false,
      // afterSet: AfterSet.ToggleInsurancePremiumOverride,
    },

    UseSpecificDBAccrualRates: {
      value: false,
    },
    UserSpecifiedDBAccrualRates: {
      value: 0,
      range: {
        min: 0,
        max: 0.3,
      },
      step: 0.01,
    },

    UseSpecificDBAccrualRates_2: {
      value: false,
    },
    UserSpecifiedDBAccrualRates_2: {
      value: 0,
      range: {
        min: 0,
        max: 0.3,
      },
      step: 0.01,
    },
  },

  inputs: {
    CalculationDate: { value: new AdvDate() },
    Working: {
      value: true,
      beforeSet: BeforeSet.Working,
    },

    InsurancePremium: {
      value: 468,
      // afterSet: AfterSet.ToggleInsurancePremiumOverride,
    },

    OverrideFundDefaultInsurancePremiums: {
      value: false,
      // afterSet: AfterSet.ToggleInsurancePremiumOverride,
    },

    InsurancePremium_2: 0, // doesn't exist

    WageInflationIndex: { value: [0.037] },

    PriceInflationIndex: { value: [0.025] },

    Married: { value: false },

    IncludeAgePension: { value: true },

    HomeOwner: { value: true },

    IncludePartner: {
      value: false,
      afterSet: AfterSet.IncludePartner,
    },

    RunOutAge: {
      value: 92,
      range: {
        min: Min.AfterRetirementAge,
        max: 100,
      },
      step: 1,
      beforeSet: BeforeSet.Clamp,
    },

    AgeNow: {
      value: 50,
      range: {
        min: 18,
        max: 74,
      },
      step: 1,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.Age,
    },

    Salary: { value: 70000 },

    AccumulationMemberCoreContributionRate: { value: 0 },

    DBMemberCoreContributionRate: { value: 0 },

    PostTaxContributions: { value: true },

    OtherAssets: {
      value: 0,
      range: Range.FiveHundredThousand(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
    },

    AccruedDBMultiple: { value: 0 },

    AccountType: { value: 1 },

    EmployerContributionRate: { value: 0.1275 },

    ContributionRateSubsequentEmployment: { value: 0 },

    DeferredRetirementBalance: {
      value: 0,
      range: Range.TwoMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
    },

    InvestmentOption: { value: 4 },

    InvestmentOptionInRetirement: { value: 4 },

    MemberType: { value: 1 },

    OneOffContribution: {
      value: 0,
      range: {
        min: 0,
        max: Max.OneOffContribution,
      },
      step: 1000,
      beforeSet: BeforeSet.Clamp,
    },

    OneOffContributionMadeAtAge: {
      value: 50,
      range: {
        min: Min.AgeNow,
        max: Max.BeforeRetirementAge,
      },
      disabled: Disabled.OneOffContributionMadeAtAge,
      beforeSet: BeforeSet.Clamp,
    },

    PartTimeWorkDaysPerWeek: {
      value: 5,
      range: {
        min: 0,
        max: 5,
      },
      step: 0.5,
      beforeSet: BeforeSet.Clamp,
    },

    PartTimeWorkFromAge: {
      value: 50,
      range: {
        min: Min.AgeNow,
        max: Max.BeforeRetirementAge,
      },
      step: 1,
      disabled: Disabled.OneOffContributionMadeAtAge,
      beforeSet: BeforeSet.Clamp,
    },

    PartTimeWorkYearsDuration: {
      value: 0,
      range: {
        min: 0,
        max: Max.PartTimeWorkYearsDuration,
      },
      step: 1,
      beforeSet: BeforeSet.Clamp,
    },

    TargetIncome: { value: 46500 },

    PreTaxMemberContributions: { value: 0 },

    PostTaxMemberContributions: { value: 0 },

    RetirementAge: {
      value: 67,
      range: {
        min: Min.RetirementAge,
        max: 75,
      },
      beforeSet: BeforeSet.Clamp,
    },

    Sex: {
      value: 'Female',
      afterSet: AfterSet.Sex,
    },

    SuperannuationBalance: { value: 0 },
    WithdrawalAtRetirement: {
      value: 0,
      range: Range.OneMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
    },

    // Partner
    Working_2: {
      value: true,
      beforeSet: BeforeSet.Working2,
    },

    AgeNow_2: {
      value: 50,
      range: {
        min: 18,
        max: 74,
      },
      step: 1,
      beforeSet: BeforeSet.Clamp,
      afterSet: AfterSet.Age2,
    },

    Salary_2: { value: 70000 },

    AccountType_2: { value: 1 },

    AccruedDBMultiple_2: { value: 0 },

    PostTaxContributions_2: { value: true },

    AccumulationMemberCoreContributionRate_2: { value: 0 },

    ContributionRateSubsequentEmployment_2: { value: 0 },

    DBMemberCoreContributionRate_2: { value: 0 },

    DeferredRetirementBalance_2: {
      value: 0,
      range: Range.TwoMillion(1000),
      step: 1000,
      beforeSet: BeforeSet.Clamp,
    },

    EmployerContributionRate_2: { value: 0.1275 },

    InvestmentOption_2: { value: 3 },

    InvestmentOptionInRetirement_2: { value: 4 },

    MemberType_2: { value: 1 }, // Was set to 0 by default, but that seems to be incorrect - changes immediately when you change the partner salary

    OneOffContribution_2: {
      value: 0,
      range: {
        min: 0,
        max: Max.OneOffContribution2,
      },
      step: 1000,
      beforeSet: BeforeSet.Clamp,
    },

    OneOffContributionMadeAtAge_2: {
      value: 50,
      range: {
        min: Min.AgeNow2,
        max: Max.BeforeRetirementAge2,
      },
      disabled: Disabled.OneOffContributionMadeAtAge2,
      beforeSet: BeforeSet.Clamp,
    },

    PartTimeWorkDaysPerWeek_2: {
      value: 5,
      range: {
        min: 0,
        max: 5,
      },
      step: 0.5,
      beforeSet: BeforeSet.Clamp,
    },

    PartTimeWorkFromAge_2: {
      value: 50,
      range: {
        min: Min.AgeNow2,
        max: Max.BeforeRetirementAge2,
      },
      step: 1,
      disabled: Disabled.OneOffContributionMadeAtAge2,
      beforeSet: BeforeSet.Clamp,
    },

    PartTimeWorkYearsDuration_2: {
      value: 0,
      range: {
        min: 0,
        max: Max.PartTimeWorkYearsDuration2,
      },
      step: 1,
      beforeSet: BeforeSet.Clamp,
    },

    PreTaxMemberContributions_2: { value: 0 },
    PostTaxMemberContributions_2: { value: 0 },
    RetirementAge_2: {
      value: 67,
      range: {
        min: Min.RetirementAge2,
        max: 75,
      },
      beforeSet: BeforeSet.Clamp,
    },

    Sex_2: { value: 'Male' },

    SuperannuationBalance_2: { value: 0 },

    WithdrawalAtRetirement_2: { value: 0 },

    UseSpecificDBAccrualRates: {
      value: false,
    },
    UserSpecifiedDBAccrualRates: {
      value: 0,
      range: {
        min: 0,
        max: 0.3,
      },
      step: 0.01,
    },

    UseSpecificDBAccrualRates_2: {
      value: false,
    },
    UserSpecifiedDBAccrualRates_2: {
      value: 0,
      range: {
        min: 0,
        max: 0.3,
      },
      step: 0.01,
    },

  },
};
